import { http } from './http';
import { baseURL, editorEndpoint } from './wpConfig';
import { IPublishInfo } from './types';
import { IBDDef } from '../components/BD';
import { UserCredentials } from './wpAuth';

export const saveTemp = (bdDef: IBDDef): Promise<{ URL: string }> => {
    const endPoint: string = `${baseURL}${editorEndpoint}/savetemp`;
    return http.post<{ URL: string }>(endPoint, { definition: bdDef });
};

export const publishBD = (userCredentials: UserCredentials, bd: IPublishInfo): Promise<{ status: string, posts: any[], permalink: string }> => {
    const endPoint: string = `${baseURL}${editorEndpoint}/create`;
    return http.post(endPoint, { bd }, { auth: userCredentials });
};

export const updateBD = (userCredentials: UserCredentials, bd: IPublishInfo): Promise<{ status: string, posts: any[], permalink: string }> => {
    const endPoint: string = `${baseURL}${editorEndpoint}/update`;
    return http.post(endPoint, { bd }, { auth: userCredentials });
};

export interface ScrapeResponse {
    success: boolean;
    url: string;
    og_data: {
        site_name?: string;
        locale?: string;
        title?: string;
        description?: string;
        url?: string;
        type?: string;
        image?: string;
        'image:width'?: string;
        'image:height'?: string;
        'image:type'?: string;
        'article:section'?: string;
        'article:content_tier'?: string;
        'article:author'?: string;
        'article:published_time'?: string;
        favicon?: string;
    };
    extracted_at: string;
}

export const scrapeUrl = (url: string): Promise<ScrapeResponse> => {
    const endPoint: string = `${baseURL}${editorEndpoint}/scrape?url=${encodeURIComponent(url)}`;
    return http.get<ScrapeResponse>(endPoint);
};


